<kendo-dialog class="helpVideoModal" *ngIf="showModalBox" (close)="closeModal()" [minWidth]="250" [width]="1000">
	<iframe
		width="1000"
		height="596"
		[src]="currentHelpVideo.url"
		title="{{ currentHelpVideo.title }}"
		frameborder="0"
		allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
		allowfullscreen>
	</iframe>
</kendo-dialog>

<kendo-dialog class="helpVideoModal" *ngIf="showContentTypeVideo" (close)="closeContentTypeVideo()" [minWidth]="250" [width]="1000">
	<div [innerHTML]="currentContentTypeVideo"></div>
</kendo-dialog>

<div class="header-help-content d-flex" [class.has-videos]="helpVideos?.length || hasEditRight">
	<div class="col-12 px-0" *ngIf="helpVideos?.length || hasEditRight">
		<h5 class="grey-text text-darken-3 px-3 pt-3 pb-2 m-0 d-flex align-items-center">
			<i class="mdi-av-play-circle-outline pr-2" style="font-size: 1.6rem;"></i>
			Tutoriale
			<i *ngIf="hasEditRight" class="mdi-editor-mode-edit pink-text text-accent-2 cursor-pointer ml-auto" style="font-size: 1.6rem;" (click)="openHelpVideoEditor.emit()"></i>
		</h5>
		<div *ngFor="let helpVideo of helpVideos" class="d-flex p-3 cursor-pointer helpAction align-items-center" (click)="onVideoClick(helpVideo)">
			<img class="video-thumbnail" [src]="helpVideo.thumbnail" />
			<div class="d-flex flex-column pl-3">
				<span class="cyan-text">{{ helpVideo.title }}</span>
				<a *ngIf="helpVideo.full_content_link" class="black-text px-0" [href]="helpVideo.full_content_link" target="_blank"
					(click)="$event.stopPropagation()">Mai multe informații</a>
			</div>
		</div>
	</div>

	<div *ngIf="hasEditRight || helpMenuItems?.length || helpUserGuides?.length"
		class="px-0 {{ (helpVideos?.length || hasEditRight) ? 'col-12' : 'col-24' }}">
		<h5 class="grey-text text-darken-3 px-3 pt-3 pb-2 m-0 d-flex align-items-center">
			<i class="mdi-av-my-library-books pr-2" style="font-size: 1.6rem;"></i>
			Documentație și resurse
			<i *ngIf="hasEditRight" class="mdi-editor-mode-edit pink-text text-accent-2 cursor-pointer ml-auto" style="font-size: 1.6rem;"
				(click)="openHelpMenuEditor.emit()"></i>
		</h5>
		<div *ngFor="let item of helpMenuItems" class="d-flex flex-column px-3 py-2 helpAction">
			<a class="cyan-text p-0" target="_blank" [href]="item.link">{{ item.title }}</a>
			<span class="grey-text text-darken-3">{{ item.description }}</span>
		</div>
		<div *ngFor="let guide of helpUserGuides" class="d-flex flex-column px-3 py-2 helpAction">
			<a class="cyan-text p-0" target="_blank" [href]="guide.link" rel="noopener noreferrer">{{ guide.title }}</a>
			<span class="grey-text text-darken-3">{{ guide.description }}</span>
		</div>
	</div>
</div>